<!-- תפריט ולוגו בדף הבית ודפים אחרים מובייל -->
<div class="container-fluid" [ngClass]="{'hide-logo-row-home-page': headerService.isHomePage, 'header-container-scroll': isInAMiddleOfScroll.value}">
  <div class="row">
    <div class="header-first-row">
        <div class="basket-link-icon" [ngClass]="{'scroll-basket': scrollHeight.value>0}" routerLink="/aoc/archonline_basket">
          <div class="num-of-orders"  [ngClass]="{'num-of-orders-active': trnsItems.length>0}">{{trnsItems.length}}</div>
        </div>
        <!-- לוגו מובייל -->
        <a class="logo-wrapper" [ngClass]="{'moveLogo': scrollHeight.value>0}" routerLink="/">
    
    
          <div title="תכנון אונליין" alt="תכנון אונליין" [ngClass]="{'online-logo-do-amim': scrollHeight.value===0}" class="online-logo anim-to-disable"></div>
          <div class="home-title anim-to-disable" [ngClass]="{'home-title-do-anim': scrollHeight.value===0, 'home-title-dont-anim': scrollHeight.value>0}">
            <div class="home-title-txt"></div>
          </div>
    
        </a>
    </div>
    
    <!-- תפריט מובייל -->
    <div class="col-sm-12 online-menu-wrapper-mobile" [ngClass]="{'hideMobileMenu': scrollHeight.value>0, 'showMobileMenu': scrollHeight.value===0 && !headerService.justArrivedPage}">

      <div class="online-menu-mobile row">
        <a *ngFor="let menuItem of menuItems" class="menu-item-link" [class.order-item-anim]="menuItem.id == 1" [ngClass]="{'menuActive': currentPath.indexOf(menuItem.link)>-1, 'order-item-anim': menuItem.id == 1 && currentPath.indexOf(productDetailStartPath)<0 }"
          routerLink="{{menuItem.link}}">{{menuItem.title}}</a>
        <a class="menu-item-link menu-link-studio" href="http://gilarch.co.il/">סטודיו גיל אדריכלות</a>
      </div>
    </div>
  </div>
</div>